<template>
  <div>
    <div class="sig-wrapper">
      <canvas ref="canvas" class="sig-canvas"></canvas>
    </div>

    <div class="mt-3 d-flex justify-center">
      <v-btn small color="warning" @click="clear">Limpar</v-btn>
    </div>
  </div>
</template>

<script>
import SignaturePad from "signature_pad";

export default {
  name: "SignaturePad",
  props: {
    value: { type: String, default: null }, // para pré-carregar se quiseres
  },
  data() {
    return {
      pad: null,
    };
  },
  mounted() {
    this.init();
    window.addEventListener("resize", this.resizeCanvas);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeCanvas)

    const canvasEl = this.$refs.canvas
    if (canvasEl) {
      canvasEl.removeEventListener("mouseup", this.emitNow)
      canvasEl.removeEventListener("touchend", this.emitNow)
      canvasEl.removeEventListener("pointerup", this.emitNow)
    }
  },
  methods: {
    emitNow() {
      const url = this.getDataUrl()
      this.$emit("input", url)
      this.$emit("change", url)
    },
    init() {
      const canvas = this.$refs.canvas;
      this.pad = new SignaturePad(canvas, {
        minWidth: 1,
        maxWidth: 2.5,
      });

      this.resizeCanvas();

      // Se vier uma assinatura já existente (base64), desenha-a
      if (this.value) {
        this.loadFromDataUrl(this.value);
      }

      this.pad.onEnd = this.emitNow
      const canvasEl = this.$refs.canvas
      canvasEl.addEventListener("mouseup", this.emitNow)
      canvasEl.addEventListener("touchend", this.emitNow)
      canvasEl.addEventListener("pointerup", this.emitNow)

    },

    resizeCanvas() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;

      const ratio = Math.max(window.devicePixelRatio || 1, 1);

      // largura do wrapper
      const parent = canvas.parentElement;
      const width = parent ? parent.clientWidth : 600;
      const height = 220;

      // guarda desenho atual antes de resize
      const data = this.pad && !this.pad.isEmpty() ? this.pad.toData() : null;

      canvas.width = width * ratio;
      canvas.height = height * ratio;
      canvas.getContext("2d").scale(ratio, ratio);

      canvas.style.width = width + "px";
      canvas.style.height = height + "px";

      if (this.pad) {
        this.pad.clear();
        if (data) this.pad.fromData(data);
      }
    },

    clear() {
      if (!this.pad) return;
      this.pad.clear();
      this.$emit("input", null);
      this.$emit("change", null);
    },

    isEmpty() {
      return !this.pad || this.pad.isEmpty();
    },

    getDataUrl() {
      if (!this.pad || this.pad.isEmpty()) return null;
      // PNG base64
      return this.pad.toDataURL("image/png");
    },

    loadFromDataUrl(dataUrl) {
      if (!this.pad || !dataUrl) return;
      this.pad.fromDataURL(dataUrl);
      this.$emit("input", dataUrl);
    },
  },
};
</script>

<style scoped>
.sig-wrapper {
  border: 1px dashed #bbb;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
}
.sig-canvas {
  display: block;
  width: 100%;
  height: 220px;
  touch-action: none; /* importante p/ tablet */
}
</style>
